export default __webpack_public_path__ + "static/media/mongo.ec30537f.png";